import { css } from '@emotion/react'
import { useEffect } from 'react'
import XLogo from '../Icons/XTwitter'
import { palette } from '../styles/colors'
import Button from './Button'

const rootStyles = css({
    height: 40,
})

const textStyles = css({
    paddingLeft: 6,
    flex: 'none',
    fontFamily: 'inherit',
    fontSize: 13,
    fontWeight: 500,
})

const buttonOverrides = css({
    color: palette.headerText,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    justifyContent: 'center',
    height: '40px',
    width: '196px',
    textTransform: 'none',
})

const ButtonLoginX = () => {
    useEffect(() => {
        const twitterButtonScript = (event) => {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            const domain = '.' + document.domain.replace(/.*?(\w+\.\w+)$/, '$1')
            // is this message for us?
            if (
                event?.origin?.indexOf(domain) &&
                event?.origin?.indexOf(domain) + domain.length ===
                    event?.origin?.length &&
                event?.data &&
                typeof event.data === 'string' &&
                event?.data?.indexOf('http') === 0
            ) {
                const url =
                    event.data +
                    location.search
                        .replace(/^\?/, '&')
                        .replace(/&request=\w+/, '') +
                    '&load=app'

                // indicate that the client is to be returned to app.mfc
                location.href = url
            }
            // else {
            //     console.log(
            //         'message received from another origin',
            //         domain,
            //         event.origin,
            //     )
            // }
        }
        window.addEventListener('message', twitterButtonScript)
        return () => {
            window.removeEventListener('message', twitterButtonScript)
        }
    }, [])
    return (
        <section css={rootStyles}>
            <Button
                onClick={() => window.Twitter_SignIn()}
                id="twitter-button"
                className="twitter_button"
                css={buttonOverrides}
                clean
                border
            >
                <XLogo />
                <div css={textStyles}>Sign in with Twitter</div>
            </Button>
        </section>
    )
}

export default ButtonLoginX
